<style lang="less">
    .find .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.6rem .2rem .2rem;
        z-index: 9;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            background:#FFFDE4;
            padding:.2rem .4rem 0;
            div.play_trast_con{
                width:100%;
                height:100%;
                // overflow-x: hidden;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
        }
    }
    .find .play_trast_con{
        width:100%;
        height:auto;
        padding:0.2rem 0.2rem .4rem;
        background:url("../assets/images/blackboard3-phone.png") no-repeat;
        background-size:100% 100%;
        position: relative;
        img{
            width:100%;
            height:auto;
            display: block;
            border-radius: .1rem;
            border: 0.04rem solid #7F2D00;
            margin: -.08rem 0;
        }
        >.shade{
            width:100%;
            height:100%;
            position: absolute;
            font-size: .8rem;
            color:#fff;
            .an_wrong .btnHover{
                margin:.2rem auto 0;
            }
        }
    }
    .find .tra_bottom{
        width:100%;
        margin:.6rem auto 0;
        padding:0 .4rem .2rem;
        >.imgs{
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width:1.3rem;
                height:auto;
                display: block;
                transition: all .3s;
            }
            img.active{
                transform: scale(1.2);
            }
        }
        .btnHover{
            margin:.2rem auto 0;
        }
    }
</style>
<template>
    <div class="find" @touchmove.prevent>
        <div class="pd">
            <div class="art_text_con"><!-- 蓝底 padding -->
                <img src="../assets/images/up-article-phone.png" alt="">
                <div class="art_inner"><!-- 黄底 padding -->
                    <div>
                        <div class="play_trast_con">
                            <img v-if="answer" :src="imgBaseUrl + gameData.question.answer" alt="">
                            <img v-else :src="imgBaseUrl + gameData.question.ask" alt="">
                            <div v-if="is_answered" class="shade">
                                <div class="an_right" v-if="answer">
                                    <span>答對了！</span>
                                </div>
                                <div v-else class="an_wrong">
                                    <span>答錯了</span>
                                    <div class="btnHover" @click="replay">再玩一次</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tra_bottom">
                        <div class="imgs">
                            <img @click="choiced=index" :class="{'active':choiced===index}" v-for="(item,index) in gameData.opts" :key="index" :src="imgBaseUrl + item.text" alt="">
                        </div>
                        <div class="btnHover" v-if="!is_answered" @click="sureAnswer">確認</div>
                    </div>
                </div>
                <img src="../assets/images/down-article-phone.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        gameData:{
            type:Object,
            default:{},
        },
        game_id:{
            type:String,
            default:'1',
        },
        date:{
            type:String,
            default:'',
        },
        push_id:{
            type:String,
            default:'',
        }
    },
    data(){
        return {
            choiced:'',
            answer:false,           //是否答对
            is_answered:false,      //是否已作答
            data:{
                question:'____裏，長出嫩苗，好綠。',
                opts:[
                    {
                        id:1,
                        img:require('../assets/images/wrong1.png'),
                        is_right:'wrong',
                    },
                    {
                        id:2,
                        img:require('../assets/images/wrong2.png'),
                        is_right:'wrong',
                    },
                    {
                        id:3,
                        img:require('../assets/images/right-answer.png'),
                        is_right:'right',
                    }
                ],
            } 
        }
    },
    mounted(){
    },
    methods:{
        replay(){
            this.answer=false;
            this.choiced='';
            this.is_answered = false;
        },
        sureAnswer(){
            // if(this.data.opts[this.choiced].is_right == 'right'){
            //     this.answer = true;
            // }else{
            //     this.answer = false;
            // }
            // this.is_answered = true;
            let vm = this;
            console.log(111);
            if(this.choiced===''){
                return;
            }
            this.$http.get(this.baseUrl+"/Game/findPush/GaID/"+this.game_id+"/SrtSet/"+ this.gameData.opts[this.choiced].id +"/SrtTime/"+ 5 + '/pushdate/'+ this.date  +"/sn/"+ Math.random()).then(res=>{
                console.log(res)
                if(res.data.indexOf('pass')>-1){
                    // vm.status='right';
                    vm.answer = true;
                    setTimeout(()=>{
                        vm.$emit('next');
                    },3000)
                }else{
                    vm.answer = false;
                    // vm.status='wrong';
                }
                vm.is_answered = true;
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/game-find.vue